import store from '@/store';

export const marketplaceRouteGuard = (to, from, next) => {
    return store.getters.config.general.marketplace_integration ? next() : next('/dashboard');
};
